import { z } from 'zod';
import { createJsonErrorResponseHandler } from '@ai-sdk/provider-utils';

export const errorDataSchema = z.object({
  error: z.object({
    message: z.string(),

    // The additional information below is handled loosely to support
    // -compatible providers that have slightly different error
    // responses:
    type: z.string().nullish(),
    param: z.any().nullish(),
    code: z.union([z.string(), z.number()]).nullish(),
  }),
});

export type ErrorData = z.infer<typeof errorDataSchema>;

export const failedResponseHandler = createJsonErrorResponseHandler({
  errorSchema: errorDataSchema,
  errorToMessage: (data) => data.error.message,
});
